module.exports = __webpack_public_path__ + "img/identidad.4e2ae5ed.svg";